import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-24 lg:py-32"
    >
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-arena-blue/[0.06] rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Start Building Your
            <br />
            QA Agent Today
          </h2>
          <p className="mt-6 text-sm font-mono text-zinc-500 max-w-lg mx-auto leading-relaxed">
            Join hundreds of QA engineers building the next generation of AI-powered testing. Deploy your first agent in minutes.
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Button
              data-testid="cta-deploy-btn"
              className="bg-white text-black hover:bg-zinc-200 font-mono text-sm h-11 px-8 rounded-md gap-2 group"
            >
              Deploy Agent
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Button>
            <Button
              data-testid="cta-community-btn"
              variant="outline"
              className="font-mono text-sm h-11 px-8 rounded-md gap-2 border-white/[0.1] bg-white/[0.03] text-zinc-300 hover:text-white hover:bg-white/[0.06] hover:border-white/[0.15]"
            >
              <Users className="w-4 h-4" />
              Join Community
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
